export default __webpack_public_path__ + "static/media/18t.f2298127.jpg";